import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useQueryClient } from '@tanstack/react-query';
import { useForm } from '../../../../lib/components';
import { useStore } from '../../../../hooks/useStore';
import { GroupDataView } from './view';
import { GroupDataForm } from './form';
import { ProfileViewEditBox } from '../shared/profileViewEditBox';
import { Group } from '@pxtra-client-lib-legacy/gen';

export const EmployeeProfilGroupData = observer(() => {
  const { employeeStore } = useStore();
  const { employeeId } = useParams();
  const { t } = useTranslation();
  const form = useForm();
  const queryClient = useQueryClient();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const [groups, setGroups] = useState<Group[]>([]);

  useEffect(() => {
    setGroups(employeeStore.currentEmployee?.groups ?? []);
  }, [employeeStore.currentEmployee?.groups]);

  const renderView = (changeToEditMode: () => void) => {
    return <GroupDataView onAddButtonClicked={changeToEditMode} data={groups} />;
  };

  const renderEdit = () => {
    return (
      <GroupDataForm
        initialValues={{ groups: groups.map((g) => g.id) }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            if (employeeId) {
              await employeeStore.updateEmployeeGroupData(employeeId, {
                groups: values.groups
              });
              await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['employees'] }),
                queryClient.invalidateQueries({ queryKey: ['employee'] })
              ]);
            }
          } catch (error) {
            console.error(error);
          }
        }}
      />
    );
  };

  return (
    <ProfileViewEditBox
      title={t('company:GROUPS')}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={canSubmit}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
